import { curveMonotoneX, curveStepAfter, line } from 'd3-shape';
import { memo } from 'react';
import styled from 'styled-components';

const Path = styled.path`
  fill: none;
  pointer-events: none;
  vector-effect: non-scaling-stroke;
`;

const Line = memo(
  ({
    data,
    keyX,
    keyY,
    scaleX,
    scaleY,
    curve = curveMonotoneX,
    strokeWidth = 2,
    ...props
  }: any) => {
    const d = line()
      .curve(curve)
      .defined(d => !((keyX && Number.isNaN(d[keyX])) || Number.isNaN(d[keyY])))
      .x((d, i) => scaleX(keyX ? d[keyX] : i))
      .y(d => scaleY(d[keyY]))(data);

    return <Path d={d} strokeLinecap="square" strokeWidth={strokeWidth} {...props} />;
  },
);

export const LineStepped = (props: any) => (
  <Line {...props} curve={curveStepAfter} strokeLinecap="butt" />
);

export default Line;
